module.exports = __webpack_public_path__ + "static/img/5.f6a5620.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/sp/5.png
// module id = Z6xu
// module chunks = 0